import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queries = buildGraphqlQuery(
  'Board',
  `_id
  remarks
  name

`
)

export const addBoardItemQuery = gql(`
  mutation addBoardItem($input: JSON!) {
    addBoardItem(input: $input) {
      _id
      items {
        _id
        entity {
          _id
        }
      }
    }
  }
`)
